import { getDownloadURL } from "firebase/storage";
import { DiscoveryRequestTaskResponse } from "../models/DiscoveryRequestTaskResponse";
import { clean } from "../utils/utils";
import api from "./api"; // the custom Axios instance

const PATH = "/api/v1/discovery-request-task-responses"; // Adjust the path as per your API

export const DiscoveryRequestTaskResponseService = {
  async createDiscoveryRequestTaskResponse(
    file: globalThis.File | null,
    discoveryRequestData: Omit<
      DiscoveryRequestTaskResponse,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById"
    >,
  ): Promise<string> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    formData.append("title", discoveryRequestData.title!);
    if (discoveryRequestData.description)
      formData.append("description", discoveryRequestData.description);
    formData.append(
      "discoveryRequestTask",
      discoveryRequestData.discoveryRequestTask!,
    );
    formData.append("matterId", discoveryRequestData.matterId!);

    const response = await api.post(PATH, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data._id;
  },

  async getDiscoveryRequestTaskResponse(
    discoveryRequestId: string,
  ): Promise<DiscoveryRequestTaskResponse> {
    const response = await api.get(`${PATH}/${discoveryRequestId}`);
    return response.data.data; // Return null if no data found
  },

  async updateDiscoveryRequestTaskResponse(
    discoveryRequestId: string,
    updatedData: Partial<
      Omit<DiscoveryRequestTaskResponse, "_id" | "createdAt">
    >,
  ): Promise<void> {
    await api.put(`${PATH}/${discoveryRequestId}`, clean(updatedData));
  },

  async deleteDiscoveryRequestTaskResponse(
    discoveryRequestId: string,
  ): Promise<void> {
    await api.delete(`${PATH}/${discoveryRequestId}`);
  },

  async getDownloadURL(
    discoveryRequestTaskResponseId: DiscoveryRequestTaskResponse["_id"],
  ): Promise<string> {
    const response = await api.get(
      `${PATH}/${discoveryRequestTaskResponseId}/download`,
    );
    return response.data.data.url;
  },
};
